<template>
  <picker-field :label="label" :isNeedInput="isNeedInput" :is-focus="isFocus" :value="value" title="选择客户" @onchange="onchange" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="cu_code,cu_name,cc_tel"
        placeholder="输入客户编号、名称进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.cu_name}}
            <span class="list-item-status" v-if="item.cu_type">{{item.cu_type}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.cu_code}}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "客户"
    },
    isNeedInput: {
      type: Boolean,
      default: false
    },
    value: String
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/document/customer/dbfind",
      defaultCondition: [
        {
          field: "cu_statuscode",
          operation: "=",
          value: "ENABLE"
        },
        {
          field: "cu_audit_status_code",
          operation: "=",
          value: "AUDITED"
        },
      ]
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.cu_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    }
  }
};
</script>